import { ObjectSchema, number, object, mixed, string, boolean } from "yup";
import { MapProvider } from "~/types/options";
import { Options } from "./types";

type DistanceUnit = "metric" | "imperial";

export const schema: ObjectSchema<Options> = object({
  theme: string().oneOf(["day", "night"]).optional(),
  lat: number()
    .min(-90, "Must be a valid latitude.")
    .max(90, "Must be a valid latitude.")
    .when("geographyId", {
      is: (geographyId?: string) => typeof geographyId === "string",
      then: (fieldSchema) => fieldSchema.optional(),
      otherwise: (fieldSchema) => fieldSchema.required(),
    }),
  lng: number()
    .min(-180, "Must be a valid longitude.")
    .max(180, "Must be a valid longitude.")
    .when("geographyId", {
      is: (geographyId?: string) => typeof geographyId === "string",
      then: (fieldSchema) => fieldSchema.optional(),
      otherwise: (fieldSchema) => fieldSchema.required(),
    }),
  geographyId: string().optional(),
  zoom: number().optional(),
  pitch: number().optional(),
  bearing: number().optional(),
  distanceUnit: mixed<DistanceUnit>().oneOf(["metric", "imperial"]).optional(),
  cooperativeGestures: boolean().optional(),
  mapProvider: mixed<MapProvider>().optional(),
  hideAttribution: boolean().optional(),
}).noUnknown(true);
